module.exports = __webpack_public_path__ + "img/9791130604343.63f27d92.jpg";